import { ColorType } from '@grid/models/color-types.model';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ColorService {
  colorCell$ = new Subject<{
    dataId: number | string;
    columnDef: string;
    color: ColorType;
  }>();
}
